import React from "react";
import { IQuotationCard } from "./types";
import { CARD_TYPES } from "./data";

const QuotationCardComponent = (props: IQuotationCard) => {
  const {
    id,
    title,
    image,
    description,
    isActive,
    handleCardClick,
    comingSoon,
    cardType = CARD_TYPES.QUOTATION_TYPE,
  } = props;
  if (cardType == CARD_TYPES.QUOTATION_TYPE) {
    const className = `px-24 py-12 rounded-[7px] my-2 border-[0.6px] hover:shadow-lg  cursor-pointer ${
      isActive
        ? "border-primary-300 bg-primary-100 shadow-button-active"
        : "border-primary-200 bg-primary-50"
    }`;

    return (
      <div
        className={className}
        onClick={() => {
          handleCardClick && handleCardClick(id);
        }}
      >
        <h3 className="pb-8 text-16 font-semibold leading-24 text-blue-200">
          {title}
        </h3>
        <p className="text-12 font-normal leading-18 text-blue-200">
          {description}
        </p>
      </div>
    );
  } else {
    const className = `px-24 py-12 rounded-[7px] border-[0.6px] cursor-pointer flex gap-y-3 flex-col item-center justify-center ${
      isActive
        ? "border-primary-300 bg-primary-100 shadow-button-active"
        : "border-primary-200 bg-primary-50"
    }`;

    return (
      <div
        className={`relative ${className} ${comingSoon ? "pointer-events-none" : "cursor-pointer"}`}
        onClick={() => {
          if (!comingSoon && handleCardClick) {
            handleCardClick(id);
          }
        }}
      >
        {/* 🔖 Top-right highlighted ribbon badge (not blurred) */}
        {comingSoon && (
          <div className="shadow-md tracking-wider absolute right-0 top-0 z-20 rounded-bl-md rounded-tr-[6px] bg-primary-400 px-6 py-[2px] text-[10px] font-bold uppercase text-white">
            Coming Soon
          </div>
        )}

        {/* Blurred content wrapper */}
        <div>
          {/* Image */}
          <div className="h-[96px]">
            <img
              src={image}
              className="h-full w-full object-contain"
              alt="quotation-card"
            />
          </div>

          {/* Title */}
          <h4 className="text-center text-16 font-semibold leading-24">
            {title}
          </h4>
        </div>
      </div>
    );
  }
};

export default QuotationCardComponent;
